/** @jsx jsx */
import { jsx } from '@emotion/react'
import { css } from '@emotion/react/macro'

import { OnChangeEventContext, OnInputChangeEventContext } from 'react-crane'
import { DropdownProps } from '../../../shared/input/Dropdown'
import { Autocomplete } from '../../../shared/input'
import { BoardItemFragment } from '../../../../generated/graphql'

const containerCss = css`
  padding-bottom: 25px;
`

export type PlaceholderAutoCompleteProps = {
  /** Current Group Id */
  groupId: string
  /** Input Value of Dropdown */
  inputValue: string
  /** Event callback when user changes input value in dropdown */
  onInputChange: (inputVal: string) => void
  /** Event callback when a new placeholder is added */
  onChange: (placeholder: BoardItemFragment) => void
  /** List of placeholder templates returned from the search to use in the dropdown */
  placeholderTemplates: Array<BoardItemFragment>
} & Omit<DropdownProps, 'onChange' | 'onInputChange'>

export const PlaceholderAutoComplete = ({
  groupId,
  inputValue,
  onChange,
  onInputChange,
  placeholderTemplates,
  ...otherProps
}: PlaceholderAutoCompleteProps) => {
  const handleChange = (e: OnChangeEventContext) => {
    const courseValue = e.value as BoardItemFragment
    onChange(courseValue)
  }

  const onStaticOptionClick = () => {
    onChange({
      creditsMax: 0,
      creditsMin: 0,
      displaySequence: 0,
      externalCourseId: '',
      id: '',
      isActive: false,
      isCoursePlaceholder: false,
      locked: false,
      nonCourseTitle: inputValue,
      planId: '',
      required: false,
      requirementTitles: [],
      title: inputValue
    })
  }

  const handleInputChange = (e: OnInputChangeEventContext) => {
    onInputChange(e.value)
  }

  return (
    <div css={containerCss}>
      <Autocomplete
        {...otherProps}
        id={`group_${groupId}_new_placeholder`}
        inputValue={inputValue}
        label="Placeholder"
        labelKey="nonCourseTitle"
        noResultsText=""
        onChange={handleChange}
        onInputChange={handleInputChange}
        onStaticOptionClick={onStaticOptionClick}
        options={placeholderTemplates}
        showStaticOption
        valueKey="id"
      />
    </div>
  )
}

export default PlaceholderAutoComplete
